/**
 * @Description: 路由守卫
 * @author TK
 * @date 2022-05-31 13:53:17
 */
import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/pageTitle'
import { Toast } from 'vant'
import { getUserInfo } from '@/api/user'
import { getSysConfig } from '@/api/sysConfig'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async (to, from, next) => {
  // 顶部进度条开始
  // NProgress.start()
  // Toast.loading({
  //   message: '加载中...',
  //   forbidClick: true,
  //   duration: 0
  // });
  // let token = localStorage.getItem('token')
  let uName = localStorage.getItem('uName')
  let uID = localStorage.getItem('uID')
  if (uID) {
    await getUserInfo({ uID }).then((res) => {
      if (res.success) {
        store.dispatch('user/getUserInfo', res?.list[0])
      }
    })
  }
  //let { list } = await getSysConfig()
  //if (list) store.dispatch('user/getSysInfo', list[0])
  //document.title = list[0].FSiteName
  //document.querySelector('meta[name="keywords"]').setAttribute('content', list[0].FKeyWords)
  if (uName) store.dispatch('user/getUsername', uName)
  next()
  // let token = store.getters['user/accessToken']

  // if (token) {
  //   if (to.path === '/login') {
  //     next({ path: '/' })
  //     NProgress.done() // hack:
  //   } else {
  //     const hasPermissions =
  //       store.getters['user/permissions'] &&
  //       store.getters['user/permissions'].length > 0
  //     if (hasPermissions) {
  //       next()
  //     } else {
  //       try {
  //         await store.dispatch('user/getUserInfo')
  //         next({ ...to, replace: true })
  //       } catch {
  //         await store.dispatch('user/resetAccessToken')
  //         NProgress.done()
  //       }
  //     }
  //   }
  // } else {
  //   if (to.path === '/login') {
  //     next()
  //   } else {
  //     next('/login')
  //     NProgress.done()
  //   }
  // }
})
router.afterEach(() => {
  // NProgress.done()
  // Toast.clear()
  window.scrollTo(0, 0)
})
